<template>
    <vx-row><!-- style="background-color: #136d9c;"  -->
      <vx-card title="" code-toggler>
        <div class="vx-row">
          <table class="vx-col md:w-5/5 w-full mt-5" border="0px"> 
            <tr style="text-align: center;">
              <td colspan="2">
                <h2>NUEVA PLATAFORMA DE APRENDIZAJE <br> PARA AMÉRICA LATINA</h2>
              </td>
            </tr><br><br>
            <tr style="text-align: center; box-shadow: -3px 2px 51px -6px #1877FF; -moz-box-shadow: -3px 2px 51px -6px #1877FF;"><br><br>
              <table>
                <tr>
                  <td style="width: 20%;" rowspan="2" align="right">
                    <img src="../assets/images/centro_aprendizaje.png" width="70%" height="40%">
                  </td>
                  <td style="width: 30%;">
                    Para iniciar sesión <br><br>
                    <vs-button color="#1877FF" type="filled" size="middle" @click="RediccionarIniciarSesion();"> Haz click aqui</vs-button>
                  </td>
                </tr>
                <tr>
                  <td style="width: 30%;">
                    ¿Aún no tienes cuenta? <br><br>
                    <vs-button color="#1877FF" type="filled" size="middle" @click="RediccionarCrearCuenta();"> Crear una cuenta</vs-button>
                  </td>
                </tr>
              </table><br><br>
            </tr><br><br>
            <tr style="text-align: center;">
              <td colspan="2">
                <b>El Programa de Lealtad y El Programa de Aprendizaje son plataformas diferentes</b><br>
                por lo que tu usuraio y contraseña para El Programa de Lealtd no funciona<br>
                para ingresar al Programa de Aprendizaje.<br><br>
                <span style="color: #1877FF;">Para cualquier duda escribenos a soprte rewards@vivotek.com</span>
              </td>
            </tr>
          </table>
        </div>
      </vx-card>
    </vx-row>
      <!-- <ul class="con-s">
        <li v-for="(item, index) in certificaciones" :key="index" >
          <label for="">{{item.nombre}} :</label>
          <vs-switch  vs-icon-off="close" vs-icon-on="done" v-model="switchs[index]" @click="CambiarEstado(switchs[index],item.id)"></vs-switch><br>
          <div style="padding-bottom:40px" v-if='switchs[index]' > 
            <label v-if="item.certificado!=''" >Actualizar Certificado</label>
            <label v-if="item.certificado=='' || item.certificado==null" >Agregar Certificado</label>
            <vs-input accept=".pdf" type="file" @change="onFileChanged(item.id)"/> 
          </div>
          <div v-if="item.disponible == 1">
            <div v-if="item.certificado != ''">
              <div v-if="verpdf == true && item.id == valorIndex">
                <vs-button color="warning" type="filled" size="middle" @click="EsconderPDF(item.id);"> Esconder Certificado</vs-button>
              </div>
              <div v-else>
                <vs-button color="success" type="filled" size="middle" @click="VerPDF(item.id);"> Ver Certificado</vs-button>
              </div>
            </div>
            <div v-else>
            </div>
          </div>
          <div v-if="verpdf==true">
            <br>
            <div v-if="item.id == valorIndex">
              <div style="padding-bottom:40px" v-if="item.certificado!=null && item.certificado!='' && switchs[index]" > 
                <embed style="width:700px;height:900px" type="application/pdf" :src="'data:application/pdf;base64,'+item.certificado"/>
              </div>
            </div>
          </div><br><br>
        </li>
      </ul> -->
</template>
<script>
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
export default {
  data () {
    return {
      certificaciones: [],
      switchs: [],
      btnpdf: false,
      verpdf: false,
      valorIndex: "",
    }
  },
  methods: {
    init(){
    },
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    VerPDF(index){
      this.verpdf = true;
      this.valorIndex = index;
    },
    EsconderPDF(index){
      this.verpdf = false;
      this.valorIndex = index;
    },
    CambiarEstado(disponible,certificado){
      if(disponible == true){
        this.$swal({
          title: "¿Estás seguro de eliminar este certificado?",
          text: "No podrás recuperar esta información!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Si",
        }).then(async (result) => {
          if (result.value) {
            this.openLoading();
            this.$http.post('FB_Usuario','AgrEliCertificacion',{disponible,certificado},(data)=>{
              if(data==1){
                if(!disponible)
                  this.$vs.notify({title:'Certificado',text:'agregado correctamente.',color:'success',icon:'check_box',time:8000})
                else
                  this.$vs.notify({title:'Certificado',text:'eliminado correctamente.',color:'success',icon:'check_box',time:8000})
                  this.getCertificaciones();
              }else {
                this.$vs.notify({title:'Error',text:'No se pudo realizar los cambios',color:'danger',icon:'check_box',time:8000});
              }
              this.closeLoading();
            });
          }else{
            this.getCertificaciones();
          }
        });
      }else{
        this.$swal({
          title: "¿Estás seguro de agregar un certificado?",
          text: "El certificado seria un PDF!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "Si",
        }).then(async (result) => {
          if (result.value) {
            this.$http.post('FB_Usuario','AgrEliCertificacion',{disponible,certificado},(data)=>{
              if(data==1){
                if(!disponible)
                  this.$vs.notify({title:'Certificado',text:'agregado correctamente.',color:'success',icon:'check_box',time:8000})
                else
                  this.$vs.notify({title:'Certificado',text:'eliminado correctamente.',color:'success',icon:'check_box',time:8000})
                  this.getCertificaciones();
              }else {
                this.$vs.notify({title:'Error',text:'No se pudo realizar los cambios',color:'danger',icon:'check_box',time:8000});
              }
            });
          }else{
            this.getCertificaciones();
          }
        });
      }
    },
    onFileChanged(certificado) {
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append('file', file);
      formData.append('params[0]', certificado);
      this.$http.postform('FB_Usuario','GuardarCeritificado',formData,(data)=>{
        if(data){
          this.VerPDF(data);
          this.$vs.notify({title:'Alerta',text:'Certificado guardado correctamente.',color:'success',icon:'check_box',time:8000});
          this.getCertificaciones();
        }
      });
    } ,
    RediccionarIniciarSesion(){
      window.open("https://vwalatam.learnupon.com/users/sign_in");
    },
    RediccionarCrearCuenta(){
      window.open("https://latam-academy.vivotek.com/users/sign_up");
    },
  },
  mounted() {
    this.init();
  },
}
</script>
<style lang="scss">
  .custom-input-file {
    background-color: #1877FF;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    margin: 0 auto 0;
    min-height: 7px;
    overflow: hidden;
    padding: 12px;
    position: relative;
    text-align: center;
    width: 200px;
    border-radius: 10px;
    box-shadow: 200px ;
  }
  .custom-input-file .input-file {
    border: 10000px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }
</style>